import { Image } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

import mezoLogo from "#/assets/mezo-lockup.svg"
import mezoLogoRed from "#/assets/mezo-logo-inline.svg"
import { routes } from "#/shared/constants"
import { useDAppRoute, useLandingRoute, useMobileScreen } from "#/shared/hooks"
import AccountMenu from "#/ui-old/AccountMenu"

import HeaderWrapper from "./HeaderWrapper"

export default function Header() {
  const isMobileScreen = useMobileScreen()
  const isDAppRoute = useDAppRoute()

  const { isLandingHomeRoute, isLandingPageRoute } = useLandingRoute()

  if (!isDAppRoute && isMobileScreen) return null

  let logoSrc = mezoLogo
  if (isLandingHomeRoute) {
    logoSrc = mezoLogoRed
  } else if (isLandingPageRoute) {
    logoSrc = mezoLogoRed
  }

  return (
    <HeaderWrapper>
      <Link to={routes.LANDING} style={{ position: "relative", zIndex: 10 }}>
        <Image src={logoSrc} alt="Mezo Logo" />
      </Link>
      {!isMobileScreen && isDAppRoute && <AccountMenu />}
    </HeaderWrapper>
  )
}
